"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const closePlan_1 = require("../../../app/dist/closePlan");
exports.toolDef = {
    name: 'loom_close_plan',
    description: 'Finalize a completed plan: run the FINISH_PLAN transition and persist it. The done-doc body is authored per step via loom_append_done — this tool does NOT generate it. Optionally pass a notes string, written VERBATIM into the done doc (appended as a closing section if a done doc already exists, or used as the body if none does). Closing a plan that has neither notes nor an existing done doc throws — it never writes a placeholder stub. Use this tool to close plans — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            planId: { type: 'string', description: 'Plan id to close' },
            notes: { type: 'string', description: 'Optional closing notes, written verbatim into the done doc' },
        },
        required: ['planId'],
    },
};
async function handle(root, args) {
    const planId = args['planId'];
    const notes = args['notes'];
    const result = await (0, closePlan_1.closePlan)({ planId, notes }, {
        loadWeave: dist_1.loadWeave,
        saveDoc: dist_1.saveDoc,
        fs,
        loomRoot: root,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
